const VENDOR_COLORS = ['text-emerald-400', 'text-blue-400', 'text-purple-400'];
const VENDOR_BG     = ['bg-emerald-500',   'bg-blue-500',   'bg-purple-500'];

/**
 * A single vendor rating row: coloured label + five numbered rating buttons.
 * @param {{ vendorName: string, vendorIdx: number, value: number, onChange: (n: number) => void }} props
 */
export function RatingRow({ vendorName, vendorIdx, value, onChange }) {
  return (
    <div className="flex items-center gap-3 py-2">
      <div className="flex items-center gap-2 w-40 flex-shrink-0">
        <div className={`w-2.5 h-2.5 rounded-full flex-shrink-0 ${VENDOR_BG[vendorIdx]}`} />
        <span className={`text-sm font-medium truncate ${VENDOR_COLORS[vendorIdx]}`}>
          {vendorName || `Vendor ${vendorIdx + 1}`}
        </span>
      </div>
      <div className="flex gap-1.5">
        {[1, 2, 3, 4, 5].map(n => (
          <button
            key={n}
            type="button"
            data-testid={`rating-v${vendorIdx}-${n}`}
            aria-label={`Rate ${vendorName} ${n} out of 5`}
            aria-pressed={value === n}
            onClick={() => onChange(n)}
            className={`w-9 h-9 rounded-lg text-sm font-bold transition-all
              ${value >= n
                ? 'bg-emerald-600 text-white shadow-md'
                : 'bg-slate-700 text-slate-500 hover:bg-slate-600 hover:text-slate-300'}`}
          >
            {n}
          </button>
        ))}
      </div>
      <span className={`text-sm w-10 text-right font-semibold ${value ? 'text-emerald-400' : 'text-slate-600'}`}>
        {value ? `${value}/5` : '—'}
      </span>
    </div>
  );
}
